<template>
  <div class="jl-auc-modal">
    <div class="jl-auc-modal-body alt-spike">
      <div class="jl-modal-content1">
        <div class="item">
          <div class="item-spike">
            <p class="text1">用户需要支付200元押金</p>
            <p class="text2">秒杀功能可让用户在拍卖开始后获得以秒杀价拍得拍品的资格</p>
            <p
              class="text3"
            >拍卖结束后若用户未拍得拍品，押金会退还回用户账户，若用户拍得拍品，在支付时押金会抵扣货款，若用户在拍得拍品后一定时间内未支付，则押金不予退还，是否确定?</p>
          </div>
          <div class="right-box">
            <span :class="[payType === 0?'btn active':'btn']" @click="payType = 0">
              <img src="../../../assets/img/zkj-zfb.png" alt />
              支付宝
            </span>
            <!-- <span :class="[payType === 1?'btn active':'btn']" @click="payType = 1">
              <img src="../../../assets/img/zkj-weix.png" alt />
              微信
            </span>-->
          </div>
        </div>
      </div>

      <div class="item-footer">
        <button class="btn alt-1" @click="hanleCancel">取消</button>
        <button class="btn confim" @click="hanleConfim">
          确定
          <i class="el-icon-loading" v-if="cloading"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    seckillPrice: [Number, String]
  },
  data() {
    return {
      payType: 0, //支付方式 0=>支付宝 1=>微信
      cloading: false
    };
  },
  methods: {
    hanleCancel() {
      this.cloading = false;
      this.$emit("cancelClick");
    },
    hanleConfim() {
      let type = this.payType === 0 ? "payAlipay" : "payWechart";
      this.cloading = true;
      this.$emit("confimClick", { type: type });
    }
  }
};
</script>

<style lang="scss" scoped>
.jl-auc-modal {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.7);
  text-align: center;
  &::after {
    content: "";
    display: inline-block;
    vertical-align: middle;
    width: 0;
    height: 100%;
  }
  .jl-auc-modal-body {
    display: inline-block;
    vertical-align: middle;
    width: 518px;
    background-color: #fff;
    box-shadow: 0 0 18px rgba(4, 40, 104, 0.3);
    padding: 30px 0 15px 0;
    text-align: left;
  }

  .jl-modal-content1 {
    display: table;
    width: 100%;
    height: 100%;
    text-align: center;

    .item {
      display: table-cell;
      vertical-align: middle;
    }
    .item-type {
      .text1 {
        font-size: 16px;
        color: #333;
        margin-bottom: 10px;
        span {
          color: #e50011;
          margin-right: 5px;
        }
        .span1 {
          font-size: 28px;
        }
        .span2 {
          font-size: 36px;
        }
      }
      .text2 {
        font-size: 14px;
        color: #333;
        margin-bottom: 30px;
      }
    }
    .item-spike {
      p {
        display: inline-block;
      }
      .text1 {
        font-size: 20px;
        color: #e50011;
        padding-left: 30px;
        background: url("../../../assets/img/zkj-tips-icon1.png") no-repeat left
          center;
        margin-bottom: 15px;
      }
      .text2,
      .text3 {
        width: 378px;
        font-size: 14px;
        color: #333;
        margin-bottom: 15px;
      }
      .text3 {
        color: #666;
      }
    }
  }
}

.right-box {
  display: inline-block;
  vertical-align: middle;
  .text1 {
    font-size: 14px;
    color: #333;
  }
  .btn {
    position: relative;
    display: inline-block;
    vertical-align: middle;
    width: 117px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    font-size: 14px;
    color: #333;
    border: 1px solid #a8a8a8;
    margin-right: 5px;
    margin-left: 5px;
    cursor: pointer;
    &::before {
      content: "";
      position: absolute;
      right: 0;
      top: 0;
      background: url("../../../assets/img/zkj-order-select.png") no-repeat
        center center;
      background-size: cover;
    }
    &.active {
      border: 2px solid #e50011;
      &::before {
        width: 14px;
        height: 14px;
      }
    }
  }
}
.item-footer {
  margin-top: 20px;
  float: right;
  margin-right: 15px;
  .btn {
    width: 80px;
    height: 32px;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    color: #333;
    background-color: transparent;
    border: 1px solid #333;
    margin: 0 5px;
    outline: none;
    border-radius: 2px;
    cursor: pointer;
    &.confim {
      color: #fff;
      background-color: #e50011;
      border-color: #e50011;
    }
  }
}
</style>